const organizations =
{
    helmet :
    {
        title : 'Organisations' ,
        metas : []
    }
};

export default organizations ;